import { render, staticRenderFns } from "./SubjectSelectionModal.vue?vue&type=template&id=6b20dec8&scoped=true&"
import script from "./SubjectSelectionModal.vue?vue&type=script&lang=js&"
export * from "./SubjectSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./SubjectSelectionModal.vue?vue&type=style&index=0&id=6b20dec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b20dec8",
  null
  
)

export default component.exports